export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "merge-geo.worker-9ef1faa00ea13e0548b0.worker.js");
}
